import React from 'react';
import MonoButton from '../../kits/DesignKit/MonoButton';

const ZenPostHeroSection = ({
  eyebrow = 'AI-Powered Creator Tool',
  title = 'Transform Blog Posts into',
  titleAccent = 'Viral Social Content',
  subtitle = 'Mach aus einem Artikel plattform-optimierte Posts für LinkedIn, X, Instagram & Co – in Sekunden.',
  primaryCtaText = 'Live Demo starten',
  onPrimaryCta = null,
  secondaryCtaText = 'Unterstützte Plattformen',
  onSecondaryCta = null,
  stats = [],
  primaryUnderline = 'pink',
  secondaryUnderline = 'ZenBrand'
}) => {
  return (
    <section className="relative overflow-hidden py-16 sm:py-20 lg:py-24 px-4 font-mono">
      <div className="pointer-events-none absolute inset-0 opacity-80">
        <div className="absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-fuchsia-500/30 blur-[120px]" />
        <div className="absolute -bottom-24 right-10 h-72 w-72 rounded-full bg-violet-500/30 blur-[120px]" />
      </div>

      <div className="relative z-10 mx-auto max-w-6xl text-center">
        <div className="inline-flex items-center gap-2 rounded-full border border-brand bg-fuchsia-500/10 px-4 py-1.5 text-xs sm:text-sm font-semibold text-white font-mono">
          <span className="h-2 w-2 rounded-full bg-brand" />
          {eyebrow}
        </div>

        <h1 className="mt-6 text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight text-white font-mono">
          {title}
          <span className="mt-2 block bg-brand bg-clip-text text-transparent">
            {titleAccent}
          </span>
        </h1>

        <p className="mt-6 text-base sm:text-lg lg:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed font-mono">
          {subtitle}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <MonoButton
            onClick={onPrimaryCta}
            className="rounded-full border-brand bg-gradient-to-r from-fuchsia-500 to-violet-500 px-6 py-3 text-sm sm:text-base font-semibold text-white shadow-lg shadow-fuchsia-500/30 transition hover:brightness-110"
            underlineColors="ZenBrand "
          >
            {primaryCtaText}
          </MonoButton>

        </div>

        {stats.length > 0 && (
          <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-2xl border border-brand bg-slate-950/40 px-4 py-4 text-center shadow-lg shadow-slate-950/40"
              >
                <div className="text-2xl sm:text-3xl font-bold text-brand">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs sm:text-sm text-slate-400">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ZenPostHeroSection;
